module.exports = __webpack_public_path__ + "img/holdrio.ed1bfd28.png";